/**
 * all states from store
 */
export default {
  orders: {},
  in_request: false,
  period: null,
  order_cycle: {},
};
